import React from 'react'

const IntroPage = () => {
    return (
        <>
            <div className='mb-5 text-justify'>
                <h1 className='text-secondary'>Welcome to emailDB</h1>
                <p>Welcome to emailDB We are dedicated to assisting job seekers in their quest for the perfect career opportunities by providing a comprehensive list of company email addresses and career pages. These resources are intended solely for job application purposes, ensuring a more streamlined and efficient job hunt. We respect the privacy of the companies listed and encourage responsible use of this information.</p>
                <p>Please verify details on company websites before applying. While we strive to maintain accuracy, emailDB is not liable for actions taken based on this information. Thank you for choosing us as your job search partner, and we wish you the best in your career journey!</p>
            </div>
        </>
    )
}

export default IntroPage